import { useEffect, useState } from 'react';

export const usePageVisibility = () => {
    const [isPageVisible, setIsPageVisible] = useState(true);

    useEffect(() => {
        const handleChange = () => setIsPageVisible(document.visibilityState !== 'hidden');

        handleChange();

        document.addEventListener('visibilitychange', handleChange);

        return () => document.removeEventListener('visibilitychange', handleChange);
    }, []);

    return isPageVisible;
};
